const SLASH = '/';

export class URLs {
  HOME            = '';
  HOME_GOVBR            = 'govbr';
  EXTERNAL_HOME   = 'https://www.tjmg.jus.br/falecomtjmg/';
  LOGIN           = 'login';
  USUARIO         = 'usuario';
  EDITAR_USUARIO  = 'usuario' + SLASH + 'edicao';
  PESQUISAR_USUARIO = 'usuario' + SLASH + 'pesquisar-usuario';
  REDEFINIR_SENHA_EMAIL    = 'redefinir-senha-email';
  ESQUECI_SENHA_EMAIL   = 'esqueci-senha-email';
  REDEFINIR_SENHA = 'redefinir-senha';
  SUCESSO_FORM    = 'sucesso';
  SUCESSO_USER    = 'sucesso-cadastro';
  RECLAMACAO      = 'reclamacao';
  DENUNCIA        = 'denuncia';
  DENUNCIA_ANONIMA_AVISO = 'denuncia-anonima-aviso';
  DENUNCIA_ANONIMA_ACOMPANHAMENTO = 'https://sei-hml.tjmg.jus.br/sei/pesquisa_denuncia_anonima/controlador_consulta_processual.php?acao=consulta_processual_pesquisar&id_orgao=0';
  DENUNCIA_ANONIMA_RECOMENDACOES = 'denuncia-anonima-recomendacoes';
  DENUNCIA_ANONIMA = 'denuncia-anonima';
  DENUNCIA_ANONIMA_SUCESSO = 'denuncia-anonima-sucesso';
  HOME_DENUNCIA_ANONIMA = 'login?url=denuncia';
  CRITICA         = 'critica';
  ELOGIO          = 'elogio';
  SOLICITACAO     = 'solicitacao';
  SUGESTAO        = 'sugestao';
  LGPD            = 'lgpd';
  INFORMACAO      = 'informacao';
  CONSULTA        = 'consulta';
  USUARIO_INTERNO        = 'usuario-interno';
  USUARIO_INTERNO_SEM_PERMISSAO = 'usuario-interno-sem-permissao'
  MANIFESTO_OPERADOR = this.USUARIO_INTERNO + SLASH + 'manifesto';
  PESQUISA_MANIFESTO_OPERADOR = this.MANIFESTO_OPERADOR + SLASH + 'pesquisar';
  RESPOSTA_MANIFESTO_OPERADOR = this.MANIFESTO_OPERADOR + SLASH + 'resposta';
  RELATORIO = this.USUARIO_INTERNO + SLASH + 'relatorio';
  RELATORIO_POR_USUARIO = this.RELATORIO + SLASH + 'usuario';
  RELATORIO_POR_OPERADOR = this.RELATORIO + SLASH + 'operador';
  RELATORIO_POR_TEMA = this.RELATORIO + SLASH + 'tema';
  PESQUISAR_MANIFESTO_USUARIO  = 'usuario' + SLASH + 'pesquisar-manifesto-usuario';
  ATIVAR_CONTA = 'ativar-conta';
  CPE = 'cpe';
  FALE_COM_RH = 'fale-com-rh';
  LAI = 'lai';
  OPERADOR_CONSULTAR_REGISTRO_EMAIL = this.USUARIO_INTERNO + SLASH + 'operador' + SLASH + 'consultar-registro-email';
  OPERADOR_NOVO_REGISTRO_EMAIL = this.USUARIO_INTERNO + SLASH + 'operador' + SLASH + 'novo-registro-email';
}

export const URL = new URLs();

export function montarUrlDoCliente(baseUrl: string, path: string): string {
  const base = (baseUrl || '').replace(/\/+$/, '');
  const rota = (path || '').replace(/^\/+/, '');

  if (!base) {
    return rota ? `/${rota}` : '/';
  }

  return `${base}/${rota}`;
}

export const PAGINA_SUCESSO_FORM =    SLASH + URL.SUCESSO_FORM;
export const PAGINA_SUCESSO_USER =    SLASH + URL.SUCESSO_USER;
export const PAGINA_HOME =            SLASH + URL.HOME;
export const PAGINA_EXTERNAL_HOME =   URL.EXTERNAL_HOME;
export const PAGINA_LOGIN =           SLASH + URL.LOGIN;
export const REDEFINIR_SENHA =        SLASH + URL.REDEFINIR_SENHA;
export const USUARIO = URL.USUARIO;
export const EDITAR_USUARIO = SLASH + URL.EDITAR_USUARIO;
export const PESQUISAR_USUARIO = SLASH + URL.PESQUISAR_USUARIO;
export const PAGINA_HOME_USUARIO_INTERNO = SLASH + URL.USUARIO_INTERNO;
export const PAGINA_HOME_USUARIO_INTERNO_SEM_PERMISSAO = SLASH + URL.USUARIO_INTERNO_SEM_PERMISSAO;
export const PAGINA_OPERADOR_CONSULTAR_REGISTRO_EMAIL = SLASH + URL.OPERADOR_CONSULTAR_REGISTRO_EMAIL;
export const PAGINA_OPERADOR_NOVO_REGISTRO_EMAIL = SLASH + URL.OPERADOR_NOVO_REGISTRO_EMAIL;
export const PAGINA_MANIFESTO_OPERADOR = SLASH + URL.MANIFESTO_OPERADOR;
export const PAGINA_PESQUISA_MANIFESTO_OPERADOR = SLASH + URL.PESQUISA_MANIFESTO_OPERADOR;
export const PAGINA_RESPOSTA_MANIFESTO_OPERADOR = SLASH + URL.RESPOSTA_MANIFESTO_OPERADOR;
export const PAGINA_RELATORIO_POR_USUARIO = SLASH + URL.RELATORIO_POR_USUARIO;
export const PAGINA_RELATORIO_POR_OPERADOR = SLASH +  URL.RELATORIO_POR_OPERADOR;
export const PAGINA_RELATORIO_POR_TEMA = SLASH +  URL.RELATORIO_POR_TEMA;
export const PESQUISAR_MANIFESTO_USUARIO = SLASH + URL.PESQUISAR_MANIFESTO_USUARIO;
export const ATIVAR_CONTA =        SLASH + URL.ATIVAR_CONTA;
export const DENUNCIA_ANONIMA_AVISO =        SLASH + URL.DENUNCIA_ANONIMA_AVISO;
export const DENUNCIA_ANONIMA_RECOMENDACOES =        SLASH + URL.DENUNCIA_ANONIMA_RECOMENDACOES;
export const DENUNCIA_ANONIMA =        SLASH + URL.DENUNCIA_ANONIMA;
export const DENUNCIA_ANONIMA_SUCESSO =        SLASH + URL.DENUNCIA_ANONIMA_SUCESSO;
export const DENUNCIA =        SLASH + URL.DENUNCIA;
export const PAGINA_HOME_DENUNCIA_ANONIMA =            SLASH + URL.HOME_DENUNCIA_ANONIMA;
export const PAGINA_HOME_GOVBR =            SLASH + URL.HOME_GOVBR;

export const KEYCLOAK_BEARER_EXCLUDED_URLS =
[
  URL.HOME,
  URL.LOGIN,
  URL.USUARIO,
  URL.EDITAR_USUARIO,
  URL.SUCESSO_FORM,
  URL.SUCESSO_USER,
  URL.ESQUECI_SENHA_EMAIL,
  URL.REDEFINIR_SENHA_EMAIL,
  URL.REDEFINIR_SENHA,
  URL.USUARIO_INTERNO_SEM_PERMISSAO,
  URL.PESQUISAR_MANIFESTO_USUARIO
];

class urlAPI {
  PATH_AUTENTICAR_JWT   = SLASH + 'api' + SLASH + 'auth';
  PATH_USUARIO_AUTENTICADO = SLASH + 'api' + SLASH + 'authenticatedUser';
  PATH_USUARIO          = SLASH + 'usuario';
  PATH_REDEFINIR_SENHA_EMAIL     = SLASH + 'usuario' + SLASH + 'redefinirSenhaEmail';
  PATH_ESQUECI_MINHA_SENHA    = SLASH + 'usuario' + SLASH + 'esqueciMinhaSenhaEmail';
  PATH_PESQUISAR_USUARIO = SLASH + 'usuario' + SLASH + 'pesquisarUsuarios';
  PATH_REDEFINIR_SENHA  = SLASH + 'usuario' + SLASH + 'redefinirSenha';
  PATH_PESQUISAR_USUARIO_POR_NOME = SLASH + 'usuario' + SLASH + 'pesquisarPorNome';
  PATH_PESQUISAR_USUARIO_POR_ID = SLASH + 'usuario' + SLASH + 'pesquisarPorId';
  PATH_RECLAMACAO       = SLASH + 'reclamacao';
  PATH_DENUNCIA         = SLASH + 'denuncia';
  PATH_CRITICA          = SLASH + 'critica';
  PATH_ELOGIO           = SLASH + 'elogio';
  PATH_SOLICITACAO      = SLASH + 'solicitacao';
  PATH_SUGESTAO         = SLASH + 'sugestao';
  PATH_LGPD             = SLASH + 'lgpd';
  PATH_CPE              = SLASH + 'cpe';
  PATH_FALE_COM_RH              = SLASH + 'fale-com-rh';
  PATH_LAI              = SLASH + 'lai';
  PATH_INFORMACAO       = SLASH + 'informacao';
  PATH_CONSULTA         = SLASH + 'consulta';
  PATH_ASSUNTO          = SLASH + 'assunto';
  PATH_PROTOCOLO        = SLASH + 'protocolo';
  PATH_RELATORIO        = SLASH + 'relatorio';
  PATH_MANIFESTO        = SLASH + 'manifesto';



  PATH_AREA = SLASH + 'area';
  PATH_CONDUTA = SLASH + 'conduta';
  PATH_COR_RACA = SLASH + 'cor-raca';
  PATH_ESCOLARIDADE = SLASH + 'escolaridade';
  PATH_FUNCAO = SLASH + 'funcao';
  PATH_SETOR = SLASH + 'setor';
  PATH_TIPO_DEFICIENCIA = SLASH + 'tipo-deficiencia';
  PATH_PERGUNTA = SLASH + 'pergunta';
  PATH_SETOR_COMARCA = SLASH + 'setor-comarca';
  PATH_USUARIO_KC_EMAIL = SLASH + 'usuario-kc/email';
  PATH_USUARIO_EMAIL_KC = SLASH + 'usuario-email-kc';
  PATH_USUARIO_EMAIL_KC_POR_ID = this.PATH_USUARIO_EMAIL_KC + SLASH;
  PATH_USUARIO_EMAIL_KC_POR_USERNAME = this.PATH_USUARIO_EMAIL_KC + SLASH + 'username' + SLASH;


  PATH_MANIFESTO_CARREGAR = this.PATH_MANIFESTO + SLASH + 'carregar';
  PATH_FILTRAR_MANIFESTOS = this.PATH_MANIFESTO + SLASH + 'filtrar';
  PATH_MANIFESTO_EXCLUIR = this.PATH_MANIFESTO + SLASH + 'excluir';
  PATH_MANIFESTO_RESPOSTA = this.PATH_MANIFESTO + SLASH + 'resposta' + SLASH + 'salvar';
  PATH_MANIFESTO_STATUS = this.PATH_MANIFESTO + SLASH + 'status' + SLASH + 'findAll';
  PATH_RELATORIO_TIPOS_MANIFESTOS = this.PATH_RELATORIO + SLASH + 'tiposManifestos';
  PATH_RELATORIO_UNIDADES = this.PATH_RELATORIO + SLASH + 'unidades';
  PATH_RELATORIO_STATUS = this.PATH_RELATORIO + SLASH + 'status';
  PATH_RELATORIO_ASSUNTOS = this.PATH_RELATORIO + SLASH + 'assuntos';
  PATH_RELATORIO_MANIFESTOS_POR_USUARIO = this.PATH_RELATORIO + SLASH + 'manifestosPorUsuario';
  PATH_PDF_MANIFESTOS_POR_USUARIO = this.PATH_RELATORIO + SLASH + 'pdfManifestosPorUsuario';
  PATH_CSV_MANIFESTOS_POR_USUARIO = this.PATH_RELATORIO + SLASH + 'csvManifestosPorUsuario';
  PATH_RELATORIO_MANIFESTOS_POR_OPERADOR = this.PATH_RELATORIO + SLASH + 'manifestosPorOperador';
  PATH_CSV_MANIFESTOS_POR_OPERADOR = this.PATH_RELATORIO + SLASH + 'csvManifestosPorOperador';
  PATH_PDF_MANIFESTOS_POR_OPERADOR = this.PATH_RELATORIO + SLASH + 'pdfManifestosPorOperador';
  PATH_RELATORIO_MANIFESTOS_POR_UNIDADE = this.PATH_RELATORIO + SLASH + 'manifestosPorUnidade';
  PATH_CSV_MANIFESTOS_POR_UNIDADE = this.PATH_RELATORIO + SLASH + 'csvManifestosPorUnidade';
  PATH_PDF_MANIFESTOS_POR_UNIDADE = this.PATH_RELATORIO + SLASH + 'pdfManifestosPorUnidade';
  PATH_RELATORIO_MANIFESTOS_POR_TEMA = this.PATH_RELATORIO + SLASH + 'manifestosPorTema';
  PATH_CSV_MANIFESTOS_POR_TEMA = this.PATH_RELATORIO + SLASH + 'csvManifestosPorTema';
  PATH_PDF_MANIFESTOS_POR_TEMA = this.PATH_RELATORIO + SLASH + 'pdfManifestosPorTema';
  PATH_VIA_CEP = 'https://viacep.com.br/ws/';

  PATH_RELATORIO_MUNICIPIOS = this.PATH_RELATORIO + SLASH + 'municipios';
  PATH_CLASSIFICACAO          = SLASH + 'classificacao';
  PATH_CARREGAR_BANCOS = SLASH + 'banco';
  PATH_RELATORIO_ASSUNTOS_POR_MANIFESTO = this.PATH_RELATORIO + SLASH + 'assuntosPorManifesto';
  PATH_FILTRAR_MANIFESTOS_USUARIO = this.PATH_MANIFESTO + SLASH + 'filtrarManifestosUsuario';
  PATH_ATIVAR_CONTA  = SLASH + 'usuario' + SLASH + 'ativarConta';
  PATH_DENUNCIA_ANONIMA        = SLASH + 'denuncia-anonima';
  PATH_DENUNCIA_ANONIMA_SUCESSO        = SLASH + 'denuncia-anonima-sucesso';
  PATH_TOKEN_ACESSO_GOVBR = SLASH + 'usuario' + SLASH + 'tokenAcessoGovBr';
  PATH_CPF_USUARIO_GOV_BR = SLASH + 'usuario' + SLASH + 'cpfUsuarioGovBr';
  PATH_PESQUISAR_USUARIO_POR_CPF = SLASH + 'usuario' + SLASH + 'pesquisarPorCpf';
  PATH_PESQUISAR_USUARIO_POR_CPF_PENDENTE_ATIVACAO = SLASH + 'usuario' + SLASH + 'pesquisarPorCpfPendenteAtivacao';
  REFRESH_TOKEN = SLASH + 'usuario' + SLASH + 'refreshToken';



  PATH_CONDUTA_CARREGAR = this.PATH_CONDUTA + SLASH + 'carregar';
  PATH_COR_RACA_CARREGAR = this.PATH_COR_RACA + SLASH + 'carregar';
  PATH_ESCOLARIDADE_CARREGAR = this.PATH_ESCOLARIDADE + SLASH + 'carregar';
  PATH_FUNCAO_CARREGAR = this.PATH_FUNCAO + SLASH + 'carregar';
  PATH_SETOR_CARREGAR = this.PATH_SETOR + SLASH + 'carregar';

  PATH_SETOR_COMARCA_CARREGAR = this.PATH_SETOR_COMARCA + SLASH + 'carregar';
  PATH_TIPO_DEFICIENCIA_CARREGAR = this.PATH_TIPO_DEFICIENCIA + SLASH + 'carregar';
  PATH_PERGUNTA_GET_PERGUNTAS = this.PATH_PERGUNTA + SLASH + 'get-perguntas';

}

export const URL_API = new urlAPI();
